import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { MTable } from "components/Shared";
import MDialog from "components/Shared/MDialog.tsx";
import { getUserRoles, removeUserRole } from "requests/internetUsers";

const Roles = (props) => {
  const [rolesData, setRolesData] = useState([]);
  const [deleteDialogVisible, setDeleteDialogVisible] = useState(false);
  const mounted = useRef(true);
  const roleToDelete = useRef("");

  useEffect(() => {
    return () => {
      mounted.current = false;
    };
  }, []);

  useEffect(() => {
    getRoles();
    roleToDelete.current = "";
  }, [props.internetUserId]);

  const getColumnDefs = () => {
    let columnDefs = [{ name: "Role", dataSource: "roleName", style: { width: "200px" } }];
    if (props.canDelete) columnDefs.push({ name: "Delete", dataSource: getDeleteButton(), style: { width: "50px" } });
    return columnDefs;
  };

  /* eslint-disable react/display-name */
  /* eslint-disable react/prop-types */
  const getDeleteButton = () => {
    return rowData => {
      if (rowData.roleName == props.primaryRole) return null; // Authentication won't successfully delete a primary role
      return (
        <Box sx={{ width: '100%', textAlign: 'center' }}>
          <i className="md-icon material-icons" onClick={() => onDeleteClick(rowData)}>delete_forever</i>
        </Box>
      );
    };
  };
  /* eslint-enable react/display-name  */
  /* eslint-enable react/prop-types */

  const onDeleteClick = (rowData) => {
    roleToDelete.current = rowData.roleName;
    setDeleteDialogVisible(true);
  };

  const getDialogActions = () => {
    return [
      <Button variant="text" color="secondary" key="cancel" onClick={hideDeleteDialog}>Cancel</Button>,
      <Button key="delete" onClick={deleteRole} >Delete</Button>
    ];
  };

  const hideDeleteDialog = () => setDeleteDialogVisible(false);

  const deleteRole = () => {
    removeUserRole(props.internetUserId, roleToDelete.current, getRoles, mounted);
    hideDeleteDialog();
  };

  const getRoles = () => getUserRoles(props.internetUserId, updateTable, mounted);

  const updateTable = (response) => { setRolesData(response.map(x => ({ roleName: x }))); };

  return (
    <>
      <Card className="profile-card mcard card-unnested">
        <CardContent className="mcard-title">
          <span className="mcard-title-text">Roles</span>
        </CardContent>
        <CardContent sx={{ display: 'block' }}>
          <MTable
            className="tabbed-history"
            keyProperty={"roleName"}
            columnDefinitions={getColumnDefs()}
            data={rolesData}
          />
          <div>Please note: these roles are the MR2 roles and may not match the role displayed in User Information. The user's primary role listed in User Information cannot be removed.</div>
        </CardContent>
      </Card>
      <MDialog
        id="roles-delete-dialog"
        className="roles-delete-dialog"
        title="Confirm Delete"
        visible={deleteDialogVisible}
        focusOnMount={false}
        contentActions={getDialogActions()}
      >
        <>Are you sure you want to delete this role? This action cannot be undone.</>
      </MDialog>
    </>
  );

};

Roles.propTypes = {
  internetUserId: PropTypes.number.isRequired, // InternetUserId to use when getting roles
  canDelete: PropTypes.bool.isRequired, // Set this to true if the user has Authentication Edit right
  primaryRole: PropTypes.string, // The user's primary role, this one cannot be deleted
};

export default Roles;